module.exports = __webpack_public_path__ + "img/_收藏.d2ed1e53.png";